export default "__VITE_ASSET__DQj1Ik_c__"